import { List, useTable } from '@refinedev/antd';
import {
  IExperienceSession,
  IExperienceSessionFilterVariables,
} from '../../../interfaces/experience';
import { Button, Form, Input, Table } from 'antd';
import { HttpError, useNavigation } from '@refinedev/core';
import DatePicker from '../../../components/form-item/DatePicker';

export const ExperienceSessionList = () => {
  const { tableProps, searchFormProps } = useTable<
    IExperienceSession,
    HttpError,
    IExperienceSessionFilterVariables
  >({
    syncWithLocation: true,
    sorters: {
      initial: [{ field: 'createdAt', order: 'desc' }],
    },
    meta: {
      fields: [
        'id',
        'status',
        'createdAt',
        {
          child: ['name'],
          event: ['name'],
          reservation: ['date', 'startTime', 'endTime'],
        },
      ],
    },
    onSearch: (params) => {
      return [
        {
          field: 'id',
          operator: 'eq',
          value: params.id,
        },
        {
          field: 'event.name',
          operator: 'contains',
          value: params.event.name,
        },
        {
          field: 'reservation.date',
          operator: 'eq',
          value: params.reservation.date,
        },
      ];
    },
  });
  const { show } = useNavigation();

  const SearchForm = () => (
    <Form layout="inline" {...searchFormProps}>
      <Form.Item label="ID" name="id">
        <Input placeholder="ID" />
      </Form.Item>
      <Form.Item label="イベント" name={['event', 'name']}>
        <Input placeholder="イベント" />
      </Form.Item>
      <Form.Item label="イベント日" name={['reservation', 'date']}>
        <DatePicker picker="date" />
      </Form.Item>
      <Button htmlType="submit" type="primary">
        検索
      </Button>
    </Form>
  );

  return (
    <List headerProps={{ title: 'レポート一覧' }} headerButtons={<SearchForm />}>
      <Table
        {...tableProps}
        rowKey="id"
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total) => `全${total}件`,
        }}
        onRow={(record) => ({
          onClick: () => show('experienceSessions', record.id),
        })}
      >
        <Table.Column dataIndex="status" title="ステータス" />
        <Table.Column dataIndex={['child', 'name']} title="子供" />
        <Table.Column dataIndex={['event', 'name']} title="イベント名" />
        <Table.Column dataIndex={['reservation', 'date']} title="イベント日" />
        <Table.Column dataIndex={['reservation', 'startTime']} title="開始時刻" />
        <Table.Column dataIndex={['reservation', 'endTime']} title="終了時刻" />
        <Table.Column dataIndex="createdAt" title="作成日時" />
      </Table>
    </List>
  );
};
